import { render, staticRenderFns } from "./vTitles.vue?vue&type=template&id=8d16d25c&scoped=true&"
import script from "./vTitles.vue?vue&type=script&lang=js&"
export * from "./vTitles.vue?vue&type=script&lang=js&"
import style0 from "./vTitles.vue?vue&type=style&index=0&id=8d16d25c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d16d25c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("K:\\website\\tmp\\2021.7-12\\mmlzcyy_project\\screen\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d16d25c')) {
      api.createRecord('8d16d25c', component.options)
    } else {
      api.reload('8d16d25c', component.options)
    }
    module.hot.accept("./vTitles.vue?vue&type=template&id=8d16d25c&scoped=true&", function () {
      api.rerender('8d16d25c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/vTitles.vue"
export default component.exports